import { useAuthMutation } from '../auth';
import { ApiAgentRequest, request } from '../../utils';

type BypassPaymentAndSubmitProps = {
  id: string;
};

type BypassPaymentRequest = {
  data: {
    type: 'payment';
    attributes: {
      paymentStatus: 'BYPASSED';
    };
  };
};

type PaymentResource = {
  id: string;
  type: 'payment';
  attributes: {
    paymentId: string;
    paymentStatus: string;
  };
  relationships: {
    payment: { data: { id: string; type: 'payment' } };
    application: { data: { id: string; type: 'application' } };
  };
};

type BypassPaymentResponse = {
  data: PaymentResource;
};

export function useBypassPaymentAndSubmit(props: BypassPaymentAndSubmitProps) {
  const { isPending, mutate, isSuccess, isError, error } = useAuthMutation(async () => {
    return await request<BypassPaymentResponse>(
      new ApiAgentRequest(`/applications/${props.id}/payments`, {
        method: 'PUT',
        body: {
          data: {
            type: 'payment',
            attributes: {
              paymentStatus: 'BYPASSED',
            },
          },
        } as BypassPaymentRequest,
      }),
      {
        isExpectedResponse: (res): res is BypassPaymentResponse => res as boolean,
      },
    );
  });

  return {
    isLoading: isPending,
    bypassPaymentAndSubmit: mutate,
    isSuccess,
    isError,
    error,
  };
}
